export default __webpack_public_path__ + "static/media/join-success.3532cf6e.png";